import { Component } from 'react';
import PropTypes from 'prop-types';
import {
    pricesProvider,
    PRICE_HANDLER_EVENTS
} from 'rp-prices-component';

class PriceHandler extends Component {
    constructor(props) {
        super(props);
        this.onPriceReceived = this.onPriceReceived.bind(this);
        this.onPricesWillBeUpdated = this.onPricesWillBeUpdated.bind(this);
    }

    componentDidMount() {
        pricesProvider.subscribe(
            PRICE_HANDLER_EVENTS.PRICE_RECEIVED,
            this.onPriceReceived
        );
        pricesProvider.subscribe(
            PRICE_HANDLER_EVENTS.PRICES_WILL_BE_UPDATED,
            this.onPricesWillBeUpdated
        );
    }

    componentWillUnmount() {
        pricesProvider.unsubscribe(
            PRICE_HANDLER_EVENTS.PRICE_RECEIVED,
            this.onPriceReceived
        );
        pricesProvider.unsubscribe(
            PRICE_HANDLER_EVENTS.PRICES_WILL_BE_UPDATED,
            this.onPricesWillBeUpdated
        );
    }

    onPriceReceived(renderConfig) {
        this.props.onPriceReceived(renderConfig);
    }

    onPricesWillBeUpdated() {
        this.props.onClearPrices();
    }

    render() {
        return null;
    }
}

PriceHandler.propTypes = {
    onPriceReceived: PropTypes.func.isRequired,
    onClearPrices: PropTypes.func.isRequired,
};

export default PriceHandler;



// WEBPACK FOOTER //
// ./src/js/utils/PriceHandler.js